import "./index.scss";
import { groupByInitial } from "./utils/groupByInitial";

export const BrandRestrictionsList = ({ title, list }) => {
  if (!list) return null;

  const letterGroup = groupByInitial(list);

  return (
    <div className="brand-restrictions-list">
      <h2>{title}</h2>
      <ul>
        <li>
          {letterGroup.map(({ letter, list }) => (
            <div className="letter-group" key={letter}>
              <h3>{letter}</h3>
              {list.map((name) => (
                <p key={name}>{name}</p>
              ))}
            </div>
          ))}
        </li>
      </ul>
    </div>
  );
};

/*
%h2 Brands Not Accepted
%ul.unstyled
  - not_accepted_brands.each do |brand|
    - title_letter = brand.name[0].match(/[A-Za-z]/) ? brand.name[0].upcase : "#"
    - if title_letter != letter
      - letter = title_letter
      %h3= letter 
    %li= brand.name
*/
